import { filterOptions } from '@/utils/query-base'
import { formatSapDate, formatSapTime } from '@/mixins/index'
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'partner': {
    title: '客户编码',
    type: 'dialog',
    dialog: {
      component: 'ClientSelect',
      title: '客户编码'
    },
    width: 300
  },

  'cust_name': {
    title: '客户名称',
    type: 'input',
    width: 'auto'
  },
  'referral_name': {
    type: 'input',
    title: '姓名',
    width: 200
  },
  'referral_phone': {
    type: 'input',
    title: '手机号',
    width: 200
  },
}



// WEBPACK FOOTER //
// ./src/views/client-manage/config/brandRecommend.js